import { Wrench, ShieldCheck, Clock, Award } from "lucide-react";

const TRUST = [
  { Icon: Wrench, title: "ASE-Style Expertise", desc: "Decades of combined experience across every make and model." },
  { Icon: ShieldCheck, title: "Honest Estimates", desc: "Clear, written quotes before any wrench touches your vehicle." },
  { Icon: Clock, title: "Fast Turnaround", desc: "Most services completed same-day. We respect your time." },
  { Icon: Award, title: "Local & Trusted", desc: "Proudly serving Midwest City families and businesses." },
];

const About = () => {
  return (
    <section id="about" data-testid="about-section" className="bg-[#0a0a0a] py-24 lg:py-32 border-t border-[#2e2e2e]">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
        <div className="lg:col-span-5 relative">
          <div className="relative aspect-[4/5] overflow-hidden">
            <img src="https://images.pexels.com/photos/4116221/pexels-photo-4116221.jpeg"
              alt="Mid Del Auto mechanic at work" className="w-full h-full object-cover grayscale hover:grayscale-0 transition-all duration-700" />
            <div className="absolute inset-0 border-2 border-[#e10600] translate-x-4 translate-y-4 -z-10" />
          </div>
          <div className="absolute -bottom-6 -right-6 bg-[#e10600] p-6 lg:p-8 max-w-[200px] hidden lg:block">
            <div className="font-['Anton'] text-white text-5xl leading-none">30+</div>
            <div className="font-['Exo_2'] text-white/90 text-xs uppercase tracking-widest mt-2 font-bold">Years on the lift</div>
          </div>
        </div>

        <div className="lg:col-span-7">
          <div className="flex items-center gap-3 mb-6">
            <div className="h-[2px] w-12 bg-[#e10600]" />
            <span className="font-['Exo_2'] uppercase text-xs tracking-[0.4em] text-[#e10600] font-bold">Why Mid Del Auto</span>
          </div>
          <h2 className="font-['Anton'] text-white text-5xl md:text-6xl uppercase leading-[0.95] mb-6">
            More than a shop.<br />
            <span className="text-[#e10600]">A neighbor</span> you trust.
          </h2>
          <p className="font-['Exo_2'] text-gray-300 text-lg leading-relaxed mb-10">
            We've spent three decades earning Midwest City's trust one repair at a time. No upsells. No surprise fees.
            Just clear diagnostics, quality parts, and the kind of craftsmanship that keeps customers coming back —
            and sending their families.
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
            {TRUST.map(({ Icon, title, desc }) => (
              <div key={title} data-testid={`trust-${title.toLowerCase().replace(/[^a-z0-9]/g, "-")}`}
                className="border border-[#2e2e2e] hover:border-[#e10600] p-6 transition-colors">
                <Icon className="w-7 h-7 text-[#e10600] mb-4" strokeWidth={1.5} />
                <h3 className="font-['Anton'] text-white text-xl uppercase mb-2">{title}</h3>
                <p className="font-['Exo_2'] text-gray-400 text-sm leading-relaxed">{desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
